// https://vike.dev/onRenderClient
import { initAnalytics, trackPageView } from "#utils/utils";
import * as React from "react";
import { hydrateRoot } from "react-dom/client";
import type { OnRenderClientAsync } from "vike/types";
import { PageShell } from "./PageShell";

// This onRenderClient() hook only supports SSR, see https://vike.dev/render-modes for how to modify onRenderClient()
// to support SPA
const onRenderClient: OnRenderClientAsync = async (
  pageContext
): ReturnType<OnRenderClientAsync> => {
  const { Page, pageProps } = pageContext;

  // Initialize GA4 once on client and send SPA page_view
  initAnalytics({
    measurementId: (import.meta as any).env?.VITE_GA_MEASUREMENT_ID,
  });
  trackPageView(pageContext.urlPathname, document.title);

  if (!Page)
    throw new Error(
      "Client-side render() hook expects pageContext.Page to be defined"
    );
  const root = document.getElementById("react-root");
  if (!root) throw new Error("DOM element #react-root not found");
  hydrateRoot(
    root,
    <PageShell pageContext={pageContext}>
      <Page {...pageProps} />
    </PageShell>
  );
};
export { onRenderClient };
